export default "__VITE_ASSET__COM1KMzb__"